import { Id } from "@dgs/core";

export const activityKeys = {
	all: ["activities"] as const,
	lists: () => [...activityKeys.all, "lists"] as const,
	options: () => [...activityKeys.lists(), "options"] as const,
	details: () => [...activityKeys.all, "detail"] as const,
	detail: (id: Id) => [...activityKeys.details(), `${id}`],
};
